/**
 * Calculates a weighted average PPD (Per Patient Day) based on facility bed counts
 *
 * @param {Array} facilities - Array of facility objects
 * @param {Array} metricsAcrossFacilities - Array of metrics to average
 * @return {number} Weighted average value
 */
export function calculateWeightedAveragePPD(
  facilities,
  metricsAcrossFacilities
) {
  // Handle edge cases where inputs are invalid
  if (
    !facilities ||
    !metricsAcrossFacilities ||
    !Array.isArray(facilities) ||
    !Array.isArray(metricsAcrossFacilities) ||
    facilities.length === 0 ||
    metricsAcrossFacilities.length === 0
  ) {
    return 0;
  }

  const totalBeds = facilities.reduce(
    (sum, facility) => sum + (parseInt(facility?.details?.["Total Beds"]) || 0),
    0
  );

  if (totalBeds > 0) {
    const weightedSum = facilities.reduce((sum, facility, index) => {
      const facilityBeds = parseInt(facility?.details?.["Total Beds"]) || 0;
      const metric = metricsAcrossFacilities[index];
      const ppd = metric ? parseFloat(metric?.PPD) || 0 : 0;
      return sum + ppd * facilityBeds;
    }, 0);
    return parseFloat((weightedSum / totalBeds).toFixed(2));
  } else {
    // Simple average if no bed data
    const average =
      metricsAcrossFacilities.reduce(
        (sum, metric) => sum + (parseFloat(metric?.PPD) || 0),
        0
      ) / (metricsAcrossFacilities.length || 1); // Avoid division by zero
    return parseFloat(average.toFixed(2));
  }
}
